import { render, staticRenderFns } from "./Japanese.vue?vue&type=template&id=2fab021a&scoped=true"
import script from "./Japanese.vue?vue&type=script&lang=js"
export * from "./Japanese.vue?vue&type=script&lang=js"
import style0 from "./Japanese.vue?vue&type=style&index=0&id=2fab021a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fab021a",
  null
  
)

export default component.exports